// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"209":"4087ebb5","692":"28f914dc","700":"3deb0d15","848":"ac711bee"}[chunkId] + ".chunk.css";
};